import React, { useState } from "react";
import { Card, Modal, Form, Button, Row, Col } from "react-bootstrap";
import { FaPlus, FaCalendarAlt, FaClock } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Sidebar = () => {
  const [show, setShow] = useState(false);
  const [date, setDate] = useState(new Date());

  // ✅ MINI CALENDAR STATE
  const [currentDate, setCurrentDate] = useState(new Date());
const [selectedDay, setSelectedDay] = useState(null);
  // ✅ MONTH NAVIGATION
  const handlePrevMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    setCurrentDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    setCurrentDate(newDate);
  };

  // ✅ FORMAT MONTH
  const monthYear = currentDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  // ✅ GENERATE DAYS
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  );

  const endOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    0
  );

  const startDay = startOfMonth.getDay();
  const daysInMonth = endOfMonth.getDate();

  let days = [];

  for (let i = 0; i < startDay; i++) {
    days.push("");
  }

  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i);
  }

  return (
    <>
      <Card className="sidebar-card">
        <Card.Body className="p-3">

          {/* ===== MINI CALENDAR ===== */}
          <div className="mini-calendar mb-4">
            <div className="mini-header d-flex justify-content-between align-items-center">
              <button className="circle-btn" onClick={handlePrevMonth}>‹</button>
              <h6>{monthYear}</h6>
              <button className="circle-btn" onClick={handleNextMonth}>›</button>
            </div>

            <div className="mini-grid">
              {["Su","Mo","Tu","We","Th","Fr","Sa"].map(d => (
                <span key={d} className="day-name">{d}</span>
              ))}

              {/* {days.map((day, i) => (
                <span key={i} className="day-num">{day}</span>
              ))} */}
              {days.map((day, i) => (
  <span
    key={i}
    className={`day-num ${selectedDay === day ? "active-day" : ""}`}
    onClick={() => day && setSelectedDay(day)}
  >
    {day}
  </span>
))}
            </div>
          </div>

          {/* ===== EVENT SECTION ===== */}
          <div className="border-top pt-3 mt-3">
            <div className="d-flex justify-content-between align-items-center">
             <h6 className="fw-semibold">Event</h6> 
          
                 <Button  className="add-btn  btn btn-small border border-1" >      <FaPlus style={{fontSize:"8px"}}  onClick={() => setShow(true)} /></Button>
            </div>

            <p className="small text-muted">
              Drag and drop your event or click in the calendar
            </p>

            <div className="event-box green">Team Events</div>
            <div className="event-box yellow">Work</div>
            <div className="event-box red">External</div>
            <div className="event-box blue">Projects</div>
            <div className="event-box purple">Applications</div>
            <div className="event-box sky">Design</div>
          </div>

          {/* ===== UPCOMING ===== */}
          <div className="border-top pt-3 mt-3">
            <h6>
              Upcoming Event <span className="badge bg-success">15</span>
            </h6>

            <div className="up-item purple-border">
              <p>Meeting with Team Dev</p>
              <small>15 Mar 2025</small>
            </div>

            <div className="up-item pink-border">
              <p>Design System With Client</p>
              <small>24 Mar 2025</small>
            </div>

            <div className="up-item green-border">
              <p>UI/UX Team Call</p>
              <small>28 Mar 2025</small>
            </div>
          </div>

          {/* ===== UPGRADE ===== */}
          <div className="upgrade-box mt-3 text-center">
            <div className="icon-circle">⚠</div>
            <p>Enjoy Unlimited Access on a small price monthly.</p>
            <button className="upgrade-btn">Upgrade Now →</button>
          </div>
        </Card.Body>
        <style>
          {
               `
               .mini-calendar {
  text-align: center;
}

.mini-header h6 {
  font-weight: 600;
}

.circle-btn {
  border: 1px solid #ddd;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: white;
}

.mini-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
  margin-top: 10px;
}

.day-name {
  font-weight: 600;
}

.day-num {
  color: #6b7280;
}

/* EVENT COLORS */
.event-box {
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 8px;
  font-weight: 500;
}

.green { background: #c7e7d1; }
.yellow { background: #f3e5b5; }
.red { background: #f7c6c6; }
.blue { background: #cfe8f6; }
.purple { background: #e6d9f2; }
.sky { background: #d6e7ff; }

/* UPCOMING */
.up-item {
  border-left: 3px solid;
  padding-left: 10px;
  margin-bottom: 10px;
}

.purple-border { border-color: purple; }
.pink-border { border-color: pink; }
.green-border { border-color: green; }

/* UPGRADE */
.upgrade-box {
  background: #111;
  color: white;
  padding: 20px;
  border-radius: 10px;
}

.upgrade-btn {
  background: #ff6a00;
  border: none;
  padding: 8px 15px;
  color: white;
  border-radius: 6px;
}

/* MODAL */
.input-icon {
  position: relative;
}

.input-icon .icon {
  position: absolute;
//   right: 10px;
//   top: 10px;
  left:"220px;
}

.add-btn {
  cursor: pointer;
  color: #ffffff;
   background: #ff6a00;
}

.add-btn-main {
  background: #ff6a00;
  border: none;
}

.close-btn {
  border: none;
  background: none;
  font-size: 20px;
}
//   selcting-data-color
/* NORMAL DAY */
.day-num {
  color: #6b7280;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
}

/* HOVER */
.day-num:hover {
  background: #f3f4f6;
}

/* SELECTED DAY (LIKE YOUR IMAGE) */
.active-day {
  background: #ff6a00;
  color: white !important;
  font-weight: 600;
}
  
  `
          }
        </style>
      </Card>

      {/* ===== MODAL ===== */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header>
          <Modal.Title>Add New Event</Modal.Title>
          <button className="close-btn" onClick={() => setShow(false)}>×</button>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Event Name</Form.Label>
              <Form.Control />
            </Form.Group>

            {/* DATE PICKER */}
            <Form.Group className="mb-3">
              <Form.Label>Event Date</Form.Label>
              <div className="input-icon">
                <DatePicker
                  selected={date}
                  onChange={(d) => setDate(d)}
                  className="form-control"
                  dateFormat="dd-MM-yyyy"
                />
                <FaCalendarAlt className="icon" />
              </div>
            </Form.Group>

            <Row>
              <Col>
                <Form.Label>Start Time</Form.Label>
                <div className="input-icon">
                  <Form.Control type="time" />
                  <FaClock className="icon" />
                </div>
              </Col>
              <Col>
                <Form.Label>End Time</Form.Label>
                <div className="input-icon">
                  <Form.Control type="time" />
                  <FaClock className="icon" />
                </div>
              </Col>
            </Row>

            <Form.Group className="mt-3">
              <Form.Label>Event Location</Form.Label>
              <Form.Control />
            </Form.Group>

            <Form.Group className="mt-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light">Cancel</Button>
          <Button className="add-btn-main">Add Event</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Sidebar;